/** Helpers for PG home indemnity compliance validation UI (Sonar S3358). */

export function getComplianceTitleIconType(hasBlockingErrors, hasPiiWarningsOnly) {
  if (hasBlockingErrors) return "error";
  if (hasPiiWarningsOnly) return "warning";
  return "success";
}

export function getComplianceAlertConfig(hasBlockingErrors, hasPiiWarningsOnly) {
  if (hasBlockingErrors) {
    return {
      severity: "error",
      message:
        "The validation agent found issues that need attention before submitting the file to Probate Bond Pros. Close this report and re-upload corrected PDFs.",
    };
  }
  if (hasPiiWarningsOnly) {
    return {
      severity: "warning",
      message:
        "PII exposure might be possible—please double-check before submitting. You may proceed if appropriate.",
    };
  }
  return {
    severity: "success",
    message: "All checks passed. You can safely proceed to submit these document(s).",
  };
}

export function getFileValidationBorderColor(hasBlocking, hasPiiOnly) {
  if (hasBlocking) return "1px solid rgba(220,38,38,0.35)";
  if (hasPiiOnly) return "1px solid rgba(237,108,2,0.35)";
  return "1px solid rgba(16,185,129,0.35)";
}

export function getFileValidationIconColor(hasBlocking, hasPiiOnly) {
  if (hasBlocking) return "error.main";
  if (hasPiiOnly) return "warning.main";
  return "success.main";
}

export function getComplianceChipColor(status, isPiiWarning) {
  if (status === "fail") return isPiiWarning ? "warning" : "error";
  return "success";
}

export function getComplianceChipLabel(title, status, isPiiWarning) {
  if (status === "fail") {
    return isPiiWarning ? `${title}: Warning` : `${title}: Needs fix`;
  }
  return `${title}: OK`;
}

export function getComplianceIssueColor(status, isPiiWarning) {
  return getComplianceChipColor(status, isPiiWarning);
}

export function getComplianceIssueIconType(status, isPiiWarning) {
  if (status === "fail") return isPiiWarning ? "warning" : "error";
  return "success";
}

export function getComplianceDialogActionsVariant(hasBlockingErrors, hasPiiWarningsOnly) {
  if (hasBlockingErrors) return "blocking";
  if (hasPiiWarningsOnly) return "piiWarning";
  return "success";
}
